"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPackageResponse = exports.convertToImmutable = exports.simplifyCTPackages = exports.simplifyCTPackage = exports.parseDiscountsWithoutServicePlan = exports.parseDiscountsWithServicePlan = exports.isPlaPackage = exports.plaStrikeThroughKey = exports.withServicePlanKey = exports.strikeThroughKey = exports.filterByCustomerGroup = exports.simplifyPackageDiscountedPrice = exports.findDiscountKey = exports.simplifyPackagePrice = exports.simplifyCTPackageProducts = exports.attributesToObject = exports.masterVariantIsViewable = exports.commercetoolsRequestPackages = void 0;
const transformObject_1 = __importDefault(require("@simplisafe/ewok/transformObject"));
const immutable_1 = require("immutable");
const monet_1 = require("monet");
const map_1 = __importDefault(require("ramda/src/map"));
const pathEq_1 = __importDefault(require("ramda/src/pathEq"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const ts_functional_pipe_1 = require("ts-functional-pipe");
const commercetoolsClient_1 = require("../commercetools/commercetoolsClient");
const discounts_1 = require("../commercetools/discounts");
const locale_1 = require("../commercetools/locale");
const price_1 = require("../commercetools/price");
const commercetools_1 = require("../secrets/commercetools");
const safeFind_1 = require("../utils/safeFind");
const safeProp_1 = require("../utils/safeProp");
const commercetoolsRequestPackages = (locale) => {
    const { country, currency, priceChannel } = locale_1.localeInfo[locale];
    return (0, commercetoolsClient_1.commercetoolsFetch)({
        endpoint: `${commercetools_1.productUrl}/packages/product-projections/search?priceCurrency=${currency}&priceCountry=${country}&priceChannel=${priceChannel}&limit=100&filter=variants.price.currencyCode:"${currency}"&expand=masterVariant.prices[*].customerGroup.id&expand=masterVariant.prices[*].discounted.discount.id`,
        method: 'GET'
    });
};
exports.commercetoolsRequestPackages = commercetoolsRequestPackages;
const masterVariantIsViewable = (ctPackage) => monet_1.Maybe.fromNull(ctPackage?.product?.masterVariant?.attributes)
    .map(attributes => (0, immutable_1.List)(attributes)
    .some(attribute => (0, prop_1.default)('name', attribute) === 'is_viewable' && !!(0, prop_1.default)('value', attribute)))
    .getOrElse(true);
exports.masterVariantIsViewable = masterVariantIsViewable;
const attributesToObject = (ctPackage) => {
    const isViewable = (0, exports.masterVariantIsViewable)(ctPackage);
    return monet_1.Maybe.fromNull(ctPackage?.matchingVariant?.attributes)
        .getOrElse([])
        .reduce((acc, item) => ({
        ...acc,
        [(0, prop_1.default)('name', item)]: (0, prop_1.default)('value', item)
    }), {
        isViewable: isViewable,
        productName: { 'en-US': '' },
        quantity: 0,
        sku: ''
    });
};
exports.attributesToObject = attributesToObject;
const simplifyCTPackageProducts = (products) => (0, map_1.default)((0, ts_functional_pipe_1.pipe)(exports.attributesToObject, (0, transformObject_1.default)({
    isViewable: (0, prop_1.default)('isViewable'),
    name: obj => (0, prop_1.default)('productName', obj),
    quantity: (0, prop_1.default)('quantity'),
    sku: (0, prop_1.default)('sku')
})))(products || []);
exports.simplifyCTPackageProducts = simplifyCTPackageProducts;
const simplifyPackagePrice = (_package) => (0, safeProp_1.safeProp)('prices', _package)
    // TODO: the readonly array and array are incompatible
    // There has to be a way to fix this in Monda
    .chain(val => monet_1.Maybe.fromUndefined(val[0]))
    .chain((0, safeProp_1.safeProp)('value'))
    .map(price_1.formatCTPriceToNumber)
    .getOrElse(NaN);
exports.simplifyPackagePrice = simplifyPackagePrice;
const findDiscountKey = (key) => (0, safeFind_1.safeFind)((0, pathEq_1.default)(['customerGroup', 'obj', 'key'], key));
exports.findDiscountKey = findDiscountKey;
const simplifyPackageDiscountedPrice = (key) => (_package) => (0, safeProp_1.safeProp)('prices', _package)
    .chain((0, exports.findDiscountKey)(key))
    .chain((0, safeProp_1.safeProp)('discounted'))
    .chain((0, safeProp_1.safeProp)('value'))
    .map(price_1.formatCTPriceToNumber);
exports.simplifyPackageDiscountedPrice = simplifyPackageDiscountedPrice;
/**
 * Filters entries that match a customer group key.
 */
const filterByCustomerGroup = (key) => (_package) => _package.prices
    .filter((0, pathEq_1.default)(['customerGroup', 'obj', 'key'], key));
exports.filterByCustomerGroup = filterByCustomerGroup;
exports.strikeThroughKey = locale_1.LOCALE_INFO.strikeThroughKey;
exports.withServicePlanKey = locale_1.LOCALE_INFO.strikeThroughKeyWithServicePlan;
exports.plaStrikeThroughKey = locale_1.LOCALE_INFO.plaStrikeThroughKey;
/**
  * check whether the package is a PLA package or not,
  * since every PLA package is having key with this pattern: sscs3-pla-{7 digit of numbers}-en-US
  * for example: sscs3-pla-2806668-en-US
  */
const isPlaPackage = (key) => /^sscs3-pla-\d{7}-en-US/.test(key);
exports.isPlaPackage = isPlaPackage;
/**
 * Get the discount details when their is a service plan in the cart
 */
const parseDiscountsWithServicePlan = (_package) => {
    // display-discount-with-service-plan // We might need to filter by this key
    const matchingPrice = (0, exports.filterByCustomerGroup)(exports.withServicePlanKey)(_package)[0]; // I'm not sure grabbing the first one will always work, but this seems correct for now.
    /** This is the discount taken off the price */
    const discount = monet_1.Maybe.fromNull(matchingPrice?.discounted?.discount?.obj?.value);
    const absoluteDiscount = (0, discounts_1.discountToAbsoluteAmount)(discount);
    const relativeDiscount = (0, discounts_1.discountToRelativeAmount)(discount);
    /** this is how much the item is after the discount */
    const discountedPrice = absoluteDiscount.isSome() || relativeDiscount.isSome()
        ? discount.chain(() => monet_1.Maybe.fromNull(matchingPrice?.discounted?.value))
            .map(price_1.formatCTPriceToNumber)
        : (0, monet_1.None)();
    return {
        absoluteDiscountWithServicePlan: absoluteDiscount,
        discountedPriceWithServicePlan: discountedPrice,
        relativeDiscountWithServicePlan: relativeDiscount
    };
};
exports.parseDiscountsWithServicePlan = parseDiscountsWithServicePlan;
// This is very similar to the parseDiscountsWithServicePlan function,
// but I wanted to keep it seperate to make it easy to change if needed
/**
 * Get the discount details when their is not a service plan in the cart
 */
const parseDiscountsWithoutServicePlan = (_package) => {
    // display-discount-with-service-plan // We might need to filter by this key
    const matchingPrice = (0, safeProp_1.safeProp)('key', _package)
        .filter(exports.isPlaPackage)
        .chain(() => monet_1.Maybe.fromUndefined(exports.plaStrikeThroughKey)
        .chain(key => (0, exports.findDiscountKey)(key)(_package.prices)))
        .orJust((0, exports.filterByCustomerGroup)(exports.strikeThroughKey)(_package)[0]); // I'm not sure grabbing the first one will always work, but this seems correct for now.
    /** This is the discount taken off the price */
    const discount = monet_1.Maybe.fromNull(matchingPrice?.discounted?.discount?.obj?.value);
    const absoluteDiscount = (0, discounts_1.discountToAbsoluteAmount)(discount);
    const relativeDiscount = (0, discounts_1.discountToRelativeAmount)(discount);
    /** this is how much the item is after the discount */
    const discountedPrice = absoluteDiscount.isSome() || relativeDiscount.isSome()
        ? monet_1.Maybe.fromNull(matchingPrice?.discounted?.value)
            .map(price_1.formatCTPriceToNumber)
        : (0, monet_1.None)();
    return {
        absoluteDiscountWithoutServicePlan: absoluteDiscount,
        discountedPriceWithoutServicePlan: discountedPrice,
        relativeDiscountWithoutServicePlan: relativeDiscount
    };
};
exports.parseDiscountsWithoutServicePlan = parseDiscountsWithoutServicePlan;
const simplifyCTPackage = (sourcePackage) => {
    const pricesWithServicePlan = (0, exports.parseDiscountsWithServicePlan)(sourcePackage);
    const pricesWithoutServicePlan = (0, exports.parseDiscountsWithoutServicePlan)(sourcePackage);
    return (0, transformObject_1.default)({
        '@@type': () => 'package',
        absoluteDiscount: () => pricesWithoutServicePlan.absoluteDiscountWithoutServicePlan,
        absoluteDiscountWithServicePlan: () => pricesWithServicePlan.absoluteDiscountWithServicePlan,
        discountedPrice: () => pricesWithoutServicePlan.discountedPriceWithoutServicePlan,
        discountedPriceWithServicePlan: () => pricesWithServicePlan.discountedPriceWithServicePlan,
        price: exports.simplifyPackagePrice,
        products: ctpackage => (0, exports.simplifyCTPackageProducts)((0, prop_1.default)('products', ctpackage)),
        relativeDiscount: () => pricesWithoutServicePlan.relativeDiscountWithoutServicePlan,
        relativeDiscountWithServicePlan: () => pricesWithServicePlan.relativeDiscountWithServicePlan,
        sku: ctpackage => (0, prop_1.default)('key', ctpackage) || ''
    })(sourcePackage);
};
exports.simplifyCTPackage = simplifyCTPackage;
/** Parse response from package request and match package products to package key */
exports.simplifyCTPackages = (0, map_1.default)(exports.simplifyCTPackage);
/** Transform array of packages into an immutable map using the sku as keys */
const convertToImmutable = (packages) => packages.reduce((acc, item) => {
    const sku = (0, prop_1.default)('sku', item);
    return acc.set(sku, item);
}, (0, immutable_1.Map)());
exports.convertToImmutable = convertToImmutable;
const formatPackageResponse = (res) => res.chain((0, safeProp_1.safeProp)('results'))
    .toEither(Error('Package response does not contain any results'))
    .map(exports.simplifyCTPackages)
    .map(exports.convertToImmutable);
exports.formatPackageResponse = formatPackageResponse;
//# sourceMappingURL=commercetools.js.map